import noUiSlider from 'nouislider';

const stepsSlider = {
  handler: document.querySelector('.filter__steps-slider'),
  minValueInput: document.querySelector('.filter__field_type_min'),
  maxValueInput: document.querySelector('.filter__field_type_max'),
  minValueField: document.querySelector('.min_val'),
  maxValueField: document.querySelector('.max_val'),
};
const { handler = null, minValueInput, maxValueInput, minValueField, maxValueField } = stepsSlider;
const inputs = [minValueInput, maxValueInput];

if (handler) {
  noUiSlider.create(handler, {
    start: [Number(minValueInput.value), Number(maxValueInput.value)],
    connect: true,
    step: 1,
    range: {
      min: Number(minValueField.value),
      max: Number(maxValueField.value),
    },   
  });

  handler.noUiSlider.on('update', function (values, handle) {
    inputs[handle].value = values[handle].split('.')[0];
   
  });
  handler.noUiSlider.on('end', function (values, handle) {
    if (typeof JCSmartFilter !== "undefined" && JCSmartFilter !== null) {
      $('.filter__field_type_max').keyup(); 
    }     
  });  
}  
 